import { DownOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { t } = useTranslation(["menus"]);

  const items = [
    {
      key: "14",
      label: <>{t("Menu_Profile.Profile")}</>,
    },
    // {
    //   key: "15",
    //   label: <>{t("Menu_Profile.Reset_Password")}</>,
    // },
    {
      key: "16",
      label: <Link to="/logout">{t("Menu_Profile.Profile_Sign_Out")}</Link>,
    },
  ];

  return (
    <div>
      <Dropdown menu={{ items }} trigger={["hover"]}>
        <Space>
          <UserSwitchOutlined />
          {t("Menu_Profile.Profile")}
          <DownOutlined />
        </Space>
      </Dropdown>
    </div>
  );
};

export default Profile;
